import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type {
  GetBoardGroupsRequestType,
  GetBoardGroupsResponseType,
} from '../types';

export const getBoardGroups = async ({
  pathParams: { boardId, organisationId },
}: GetBoardGroupsRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/queue/groups`;

  const { data } = await apiAuthClient.get<GetBoardGroupsResponseType>(url);

  return data.data;
};
